/* global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import Select from 'react-select';
import { push } from 'react-router-redux';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import ApolloClient from 'apollo-client';
// import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
// import {
//   currentProjectIdSelector,
// } from '../../reducers/projects';

if (__CLIENT__) {
  require('react-select/dist/react-select.css');
}

// const SearchTypeAheadSelector = immutableCreatorSelector(
//   [
//     currentProjectIdSelector,
//   ],
//   (currentProjectId) => ({
//     currentProjectId,
//   })
// );

// class SearchResult extends PureComponent {
//   render() {
//     const { projectId, option } = this.props;
//     const url = `/project/${projectId}/element/${option.value}`;
//     return (
//       <Link to={url}>Hello {option.label}</Link>
//     );
//   }
// }

@withApollo
// @connect(SearchTypeAheadSelector)
export default
class SearchTypeAhead extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    currentProjectId: PropTypes.string,
    client: PropTypes.instanceOf(ApolloClient),
  };

  constructor() {
    super();
    this.state = {
      value: null,
    };
    this.getElements = this.getElements.bind(this);
    // this.gotoElement = this.gotoElement(this);
    // this.renderOption = this.renderOption(this);
  }

  debouncedFetch = debounce((searchTerm, callback) => {
    this.getElements(searchTerm)
      .then((result) => callback(null, result))
      .catch((error) => callback(error, null));
  }, 500);

  handleOnChange = (option) => {
    const { dispatch, currentProjectId } = this.props;
    const url = `/project/${currentProjectId}/element/${option.value}`;
    dispatch(push(url));
  }

  async getElements(input) {
    const { client, currentProjectId } = this.props;

    if (!input) {
      return { options: [] };
    }

    const results = await client.query({
      query: gql`
        query Search($projectId: String!, $query: String!) {
          search(projectId: $projectId, query: $query) {
              id
              name
          }
        }`,
      variables: {
        projectId: currentProjectId,
        query: input,
      },
    });

    return {
      options: results.data.search.map(s => ({ value: s.id, label: s.name })),
    };
  }

  // renderOption = option => <SearchResult option={option} />;

  render() {
    // const { currentProjectId } = this.props;
    const AsyncComponent = Select.Async;
    return (
      <AsyncComponent
        placeholder="Search..."
        multi={false}
        style={{ width: 200 }}
        className="mr-2"
        value={this.state.value}
        loadOptions={this.debouncedFetch}
        onChange={this.handleOnChange}
        // optionRenderer={o => <SearchResult projectId={currentProjectId} option={o} />}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/SearchTypeAhead.js